import { routes } from 'router'
import { MenuItemWithBadge } from '../../components/Menu/MenuItemWithBadge/MenuItemWithBadge'

export const USER_PROFILE_BREADCRUMBS = (
  fromCommunity: boolean,
  id?: string
) => [
  {
    href: fromCommunity ? routes.myCommunity : routes.settings,
    children: fromCommunity ? 'My Community' : 'Settings'
  },
  {
    children: id && id !== 'new' ? 'User profile' : 'Create user profile'
  }
]

export const PROFILE_TABS = (disabled: boolean, ccAmount?: number) => [
  {
    key: '0',
    label: 'General',
    counter: false
  },
  {
    key: '1',
    label: (
      <MenuItemWithBadge label="Contract categories" badgeText={ccAmount} />
    ),
    disabled
  }
]
